import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';
import { ChangPassState } from 'components/layouts/redux/changePass';

export const changePassSelector = (state: RootState) => state.layouts.changePass;

export const changePassSelect = createSelector(changePassSelector, (state: ChangPassState) => state);
